<template>
  <b-overlay :show="show" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
    <b-card>
      <div class="item-features">
        <div class="row text-center">
          <div class="col-12 col-md-3 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="MonitorIcon" size="35" />
              <p v-if="this.form.device_status === 'OFFLINE'" class="card-text mt-2" style="color: red;">
                {{ this.form.device_status }}
              </p>
              <p v-if="this.form.device_status === 'ONLINE'" class="card-text mt-2" style="color: greenyellow;">
                {{ this.form.device_status }}
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                STATUS
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="ActivityIcon" size="35" />
              <p class="card-text mt-2">
                {{ this.form.device_value }}°
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                TEMPERATURE
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="ZapIcon" size="35" />
              <p class="card-text mt-2">
                {{ this.form.device_value_power }}%
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                POWER
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-3 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="WifiIcon" size="35" />
              <p class="card-text mt-2">
                {{ this.form.device_signal_strength }}%
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                SIGNAL STRENGTH
              </h4>
            </div>
          </div>
        </div>
      </div>
    </b-card>
    <b-card>
      <b-row class="my-2">
        <b-col cols="12" md="5" class="d-flex align-items-center justify-content-center mb-2 mb-md-0 ">
          <div id="map"></div>
        </b-col>
        <b-col cols="12" xl="6">
          <table class="mt-2 mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">PROVINCE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.province_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">REGENCY :</span>
              </th>
              <td class="pb-50">
                {{ this.form.regency_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">SITE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.site_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">AREA :</span>
              </th>
              <td class="pb-50">
                {{ this.form.area_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">LOCATION :</span>
              </th>
              <td class="pb-50">
                {{ this.form.location_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">TYPE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_type_name }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">SERIAL NUMBER :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_serial_number }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">CODE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_code }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">MSISDN :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_msisdn }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">NOTE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_note }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">LAST ONLINE :</span>
              </th>
              <td class="pb-50">
                {{ this.form.last_online_device }}
              </td>
            </tr>

            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">LAST GET DATA :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_last_get_data }}
              </td>
            </tr>
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">LAST SENT DATA :</span>
              </th>
              <td class="pb-50">
                {{ this.form.device_last_send_data }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <div class="item-features">
        <div class="row text-center">
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="TrendingDownIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill
                  v-if="this.form.device_is_over_limit_min === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill
                  v-if="this.form.device_is_over_limit_min === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                LIMIT MIN
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="TrendingUpIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill
                  v-if="this.form.device_is_over_limit_max === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill
                  v-if="this.form.device_is_over_limit_max === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                LIMIT MAX
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="ToolIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill
                  v-if="this.form.device_is_probe_fault === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill
                  v-if="this.form.device_is_probe_fault === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                PROBE FAULT
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="ChevronsDownIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill v-if="this.form.device_is_power_low === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_is_power_low === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                POWER LOW
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="PowerIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill
                  v-if="this.form.device_is_power_shutdown === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill
                  v-if="this.form.device_is_power_shutdown === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                POWER SHUTDOWN
              </h4>
            </div>
          </div>
          <div class="col-12 col-md-2 mb-4 mb-md-0">
            <div class="w-75 mx-auto">
              <feather-icon icon="WifiOffIcon" size="35" />
              <p class="card-text mt-2">
                <b-icon-circle-fill
                  v-if="this.form.device_is_power_disconnect === false && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: greenyellow;"></b-icon-circle-fill>
                <b-icon-circle-fill
                  v-if="this.form.device_is_power_disconnect === true && this.form.device_status === 'ONLINE'"
                  animation="throb" style="color: red;" font-scale="2"></b-icon-circle-fill>
                <b-icon-circle-fill v-if="this.form.device_status === 'OFFLINE'" animation="throb" style="color: black;"
                  font-scale="2"></b-icon-circle-fill>
              </p>
              <h4 class="mt-2" style="font-size: 10px;">
                POWER DISCONECT
              </h4>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BIconCircleFill, BIcon, BDropdownItem, BDropdown, BCardBody, BRow, BInputGroup, BInputGroupAppend, BOverlay, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import { mapState } from 'vuex'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import moment from "moment";

export default {
  components: { vSelect, flatPickr, BIconCircleFill, BIcon, BDropdownItem, BDropdown, BCardBody, BInputGroup, BInputGroupAppend, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardText, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data() {
    return {
      form: {
        site_name: "",
        area_name: "",
        location_name: "",
        device_type_name: "",
        device_name: "",
        device_code: "",
        device_msisdn: 0,
        device_iccid: 0,
        device_note: "",
        device_value: 0,
        device_value_power: 0,
        device_signal_strength: 0,
        last_online_device: "",
        device_last_get_data: "",
        device_last_send_data: "",
        device_serial_number : 0,
        device_is_offline_alarm: false,
        device_is_over_limit_max: false,
        device_is_over_limit_min: false,
        device_is_probe_fault: false,
        device_is_power_low: false,
        device_is_power_shutdown: false,
        device_is_power_disconnect: false,
        device_latitude: "",
        device_longitude: "",
        device_status: "",
        province_name: "",
        regency_name: "",
      },

      show: false,
      contentData: null,
      geocoder: "",
      required
    }
  },
  computed: {
    ...mapState({
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      DeviceOptions: state => state.device.options
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
    select_6(obj) {
      return this.$store.dispatch('region/regency', obj)
    },
    select_7(obj) {
      return this.$store.dispatch('region/district', obj)
    },
    select_8(obj) {
      return this.$store.dispatch('site/getByFilter', obj)
    }
  },
  created() {
    this.$store.dispatch('site/getByNonFilter')
    this.$store.dispatch('region/province')
    this.$store.dispatch('device/getDeviceList')
  },
  methods: {
    initMap(latittute, longtitude) {
      const myLatlng = { lat: latittute, lng: longtitude }
      this.styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              { visibility: 'off' }
            ]
          }
        ],
        { name: 'Styled Map' }
      )
      this.map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: myLatlng,
      }
      )
      let fillColor
      if (this.form.device_status === "ONLINE") {
        fillColor = "#4CBB17";
      } if (this.form.device_status === "OFFLINE") {
        fillColor = "#000000";
      }
      let svgMarker = {
        path: "M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,7.5,1S14,3.9101,14,7.5z",
        fillColor: fillColor,
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
        anchor: new google.maps.Point(0, 20),
      }
      const marker = new google.maps.Marker({
        position: myLatlng,
        map: this.map,
        title: `${this.device_name} 
          <hr> Site Name : ${this.device_name} 
          <br> Device Code : ${this.device_name} 
          `,
        optimized: false,
        icon: svgMarker
      })

      // // Add a click listener for each marker, and set up the info window.
      marker.addListener('click', () => {
        infoWindow.close()
        infoWindow.setContent(marker.getTitle())
        infoWindow.open(marker.getMap(), marker)
      })

      infoWindow.open(this.map)

      // Configure the click listener.
      this.map.addListener('click', (mapsMouseEvent) => {
        // Close the current InfoWindow.
        this.form.device_latitude = mapsMouseEvent.latLng.toJSON().lat
        this.form.device_longitude = mapsMouseEvent.latLng.toJSON().lng
        infoWindow.close()

        // Create the search box and link it to the UI element.
        const input = document.getElementById("pac-input")
        const searchBox = new google.maps.places.SearchBox(input)

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

        // Bias the SearchBox results towards current map's viewport.
        map.addListener("bounds_changed", () => {
          searchBox.setBounds(map.getBounds())
        });

        // Create a new InfoWindow.
        infoWindow = new google.maps.InfoWindow({
          position: mapsMouseEvent.latLng,
        })
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({ 'location': mapsMouseEvent.latLng }, function (results, status) {
          let resultsData = results[0]
          const contentString =
            '<div id="content">' +
            '<div id="siteNotice">' +
            "</div>" +
            '<h1 id="firstHeading" class="firstHeading">' + resultsData.address_components[0].long_name + '</h1>' +
            '<div id="bodyContent">' +
            "<p>" + resultsData.formatted_address + "</p>" +
            "</div>" +
            "</div>"
          // JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2)
          infoWindow.setContent(contentString)
        })
        infoWindow.open(this.map)
      })
      // this.map.mapTypes.set('styled_map', this.styledMapType)
      // this.map.setMapTypeId('styled_map')
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.form
            this.$store.dispatch('temperature/formPostPut', formData)
              .then(res => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
              },
                err => {
                  this.show = false
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d }
      })
    },
    getData(id) {
      this.$store.dispatch('temperature/getByIdInstall', id).then(data => {
        if (data.status === "IN") {
          this.form.device_status = "ONLINE"
        }
        if (data.status === "ER") {
          this.form.device_status = "OFFLINE"
        }
        if (data.status === "FL") {
          this.form.device_status = "ERROR"
        }
        console.log(data)
        this.form.site_name = data.locations.areas.sites.name
        this.form.area_name = data.locations.areas.name
        this.form.location_name = data.locations.name
        this.form.device_type_name = data.device_types.name
        this.form.device_code = data.code
        this.form.device_serial_number = data.serial_number
        this.form.device_msisdn = data.provider_cards.msisdn
        this.form.device_iccid = data.provider_cards.iccid
        this.form.device_note = data.note
        this.form.device_value = data.value ? Number(data.value).toFixed(2) : 0
        this.form.device_value_power = data.value_power ? Number(data.value_power).toFixed(2) : 0
        this.form.signal_strength = data.signal_strength
        this.form.last_online_device = moment(data.last_online_device).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_last_get_data = moment(data.last_get_data).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_last_send_data = moment(data.last_send_data).format('YYYY-MMM-DD, HH:mm:ss')
        this.form.device_is_offline_alarm = data.is_offline_alarm
        this.form.device_is_over_limit_max = data.is_over_limit_max
        this.form.device_is_over_limit_min = data.is_over_limit_min
        this.form.device_is_probe_fault = data.is_probe_fault
        this.form.device_is_power_low = data.is_power_low
        this.form.device_is_power_shutdown = data.is_power_shutdown
        this.form.device_is_power_disconnect = data.is_power_disconnect
        this.form.device_latitude = data.latitude
        this.form.device_longitude = data.longitude
        this.form.province_name = data.locations.areas.sites.region_provinces.name
        this.form.regency_name = data.locations.areas.sites.region_regencies.name
        this.show = false
        this.initMap(parseFloat(data.latitude), parseFloat(data.longitude))
      })
    },
    // UploadRenderInstalasi(e) {
    //   if (this.form.UrlInstalasi) {
    //     URL.revokeObjectURL(this.form.UrlInstalasi);
    //   }
    //   const instalasi = e.target.files[0];
    //   this.form.instalasi = instalasi
    //   this.form.setUpload = 'upload'
    //   this.form.UrlInstalasi = URL.createObjectURL(e.target.files[0])
    // },
    // UploadRenderBast(e) {
    //   if (this.form.UrlBast) {
    //     URL.revokeObjectURL(this.form.UrlBast);
    //   }
    //   const bast = e.target.files[0];
    //   this.form.bast = bast
    //   this.form.setUpload2 = 'upload'
    //   this.form.UrlBast = URL.createObjectURL(e.target.files[0])
    // },
    // UploadRenderKalibrasi(e) {
    //   if (this.form.UrlKalibrasi) {
    //     URL.revokeObjectURL(this.form.UrlKalibrasi);
    //   }
    //   const kalibrasi = e.target.files[0];
    //   this.form.kalibrasi = kalibrasi
    //   this.form.setUpload3 = 'upload'
    //   this.form.UrlKalibrasi = URL.createObjectURL(e.target.files[0])
    // }
  },
  mounted() {
    // navigator.geolocation.getCurrentPosition((position) => {
    // this.initMap(position.coords.latitude, position.coords.longitude)
    // })
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
.card-text {
  font-weight: bold;
}

#map {
  height: 330px;
  width: 100%;
}

.font-weight-bold {
  font-weight: bold !important;
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>